import {frFR} from '@mui/material/locale';
import {adminReportTranslationsFr} from 'modules/admin/report/translations/AdminReportTranslationsFr';
import {cropsTranslationsFr} from 'modules/crops/translations/CropsTranslationsFr';
import {fieldsTranslationsFr} from 'modules/fields/translations/FieldsTranslationsFr';
import {frReportTranslations} from 'modules/report/translations/FrReportTranslations';
import {soilsTranslationsFr} from 'modules/soils/translations/SoilsTranslationsFr';
import {visioCropTranslationFr} from 'modules/visio_crop/translations/VisioCropTranslationFr';
import saMessages from '../locales/fr_FR.json';

const saLang = {
  messages: {
    ...saMessages,
    ...cropsTranslationsFr,
    ...soilsTranslationsFr,
    ...frReportTranslations,
    ...adminReportTranslationsFr,
    ...visioCropTranslationFr,
    ...fieldsTranslationsFr,
  },
  muiLocale: frFR,
  locale: 'fr-FR',
};
export default saLang;
